import React from 'react';
import FeatureCards from "../../../../components/FeatureCards/FeatureCards";
import CTA from "../../../../components/Constant/cta/CTA";
import TimelineSection from "../../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../../components/WhySection/WhySection";
import LocationTimeline from "../../../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../../../components/IntroSection/IntroSection";
import FAQList from "../../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../../../components/ServiceCards/ServiceCards";
import SEO from "../../../../utils/SEO";

export default function GibraltarInsuranceReinsuranceLicense() {

    return (
        <main className='main'>
            <SEO
                title="Gibraltar Insurance License | Reinsurance & Captive Setup "
                description="Get insurance and reinsurance licenses in Gibraltar. GFSC-regulated EU hub for captive, general, and life insurance with UK market access. "
                keywords="Gibraltar insurance license, GFSC insurance regulation, captive insurance Gibraltar, reinsurance license Gibraltar, life insurance Gibraltar, general insurance license Gibraltar, MGA Gibraltar, insurance licensing Europe "
                url="/gibraltar-insurance-reinsurance-license"
            />

            <IntroSection
                title="Gibraltar Insurance & Reinsurance License"
                subtitle="A Leading European Hub for Captive, General & Life Insurance"
                description="
                <b>Gibraltar</b> is a <b>world-class insurance center</b>, home to over <b>30% of the UK motor insurance market</b> and dozens of <b>captives, reinsurers, and specialty insurers</b>.
                <br/>
                            The jurisdiction combines <b>UK market access</b>, a <b>favorable tax system</b>, and <b>strict regulation under the GFSC</b>, making it highly attractive for <b>insurance groups</b>, <b>MGAs</b>, and <b>global corporates</b>.
                    "
                badges={
                    [
                        "Captive Insurance",
                        "General Insurance",
                        "Life Insurance",
                        "Reinsurance"
                    ]
                }
                buttonText="Request a Gibraltar Insurance Proposal →"
                buttonLink="/quote"
                imageSrc={require("../../../../assets/images/services/gibraltar-crypto-dlt-license-hero.png")}
                imageAlt=""
            />

            <section className='section'>
                <div className="container">

                    <WhySection
                        title="Why Choose Gibraltar for Insurance?"
                        blocks={
                            [
                                {
                                    items:
                                        [
                                            {
                                                title: "Tier-1 Reputation",
                                                text: "Trusted by UK, EU, and global regulators."
                                            },
                                            {
                                                title: "GFSC Regulation",
                                                text: "Aligned with EU Solvency II standards."
                                            },
                                            {
                                                title: "UK Market Access",
                                                text: "Gibraltar insurers can write UK business directly."
                                            },
                                            {
                                                title: "Captive Expertise",
                                                text: "Widely used by Fortune 500 corporations."
                                            },
                                            {
                                                title: "Tax Benefits",
                                                text: "10% corporate tax, no VAT, no capital gains."
                                            }
                                        ]
                                }
                            ]
                        }
                    />

                    <InfoBlocks
                        title='Types of Insurance Licenses in Gibraltar'
                        blocks={
                            [
                                {
                                    title: "Captive Insurance License",
                                    items:
                                        [
                                            {
                                                text: "For corporations to self-insure their risks."
                                            },
                                            {
                                                text: "Popular in aviation, shipping, energy, and finance."
                                            }
                                        ]
                                },
                                {
                                    title: "General Insurance License",
                                    items: [
                                        {
                                            text: "Covers motor, property, liability, and specialty insurance."
                                        },
                                        {
                                            text: "Strong foothold in UK motor insurance market."
                                        }
                                    ]
                                },
                                {
                                    title: "Life Insurance License",
                                    items: [
                                        {
                                            text: "For life, pensions, annuities, and health insurance providers."
                                        },
                                        {
                                            text: "Highly regulated with actuarial oversight."
                                        }
                                    ]
                                },
                                {
                                    title: "Reinsurance License",
                                    items:
                                        [
                                            {
                                                text: "Supports global reinsurance structures."
                                            },
                                            {
                                                text: "Recognized internationally for solvency and credibility."
                                            }
                                        ]
                                },
                                {
                                    title: "Insurance Intermediaries (MGAs, Brokers)",
                                    items: [
                                        {
                                            text: "Gibraltar also licenses insurance intermediaries and MGAs.",
                                        }
                                    ]
                                },
                            ]
                        }
                    />

                    <LocationTimeline
                        title="Capital & Requirements"
                        item={
                            [
                                {
                                    title: "Captives",
                                    text: "EUR 100k minimum."
                                },
                                {
                                    title: "General Insurance",
                                    text: "EUR 3m+."
                                },
                                {
                                    title: "Life Insurance",
                                    text: "EUR 3.7m+."
                                },
                                {
                                    title: "Reinsurance",
                                    text: "EUR 1.2m+."
                                },
                                {
                                    title: "Entity",
                                    text: "Gibraltar company required."
                                },
                                {
                                    title: "Resident Presence",
                                    text: "2 local directors + compliance officer."
                                },
                                {
                                    title: "Office",
                                    text: "Physical office in Gibraltar mandatory."
                                },
                                {
                                    title: "Compliance",
                                    text: "AML/KYC, solvency, actuarial standards."
                                },
                                {
                                    title: "Audit",
                                    text: "Annual audited accounts."
                                }
                            ]
                        }
                    />

                    <ServiceCards
                        title='Benefits of Gibraltar Insurance License'
                        services={
                            [
                                {
                                    title: "UK Market Access",
                                    text: "Unique post-Brexit advantage."
                                },
                                {
                                    title: "Global Recognition",
                                    text: "Solvency II equivalent regime."
                                },
                                {
                                    title: "Captive & Reinsurance Strength",
                                    text: "Leading hub in Europe."
                                },
                                {
                                    title: "Strong Regulatory Oversight",
                                    text: "GFSC credibility with investors."
                                },
                                {
                                    title: "Business Tax Regime",
                                    text: "10% corporate tax, no VAT."
                                }
                            ]
                        }
                    />

                    <FeatureCards
                        title='Licensing Process'
                        features={[
                                {
                                    title: "Pre-Application Consultation",
                                    text: "Choose license type."
                                },
                                {
                                    title: "Entity Incorporation",
                                    text: "Register Gibraltar company."
                                },
                                {
                                    title: "Application Preparation",
                                    text: "Actuarial reports, compliance manuals, financial plan."
                                },
                                {
                                    title: "GFSC Review",
                                    text: "Regulator due diligence on shareholders, directors, and solvency."
                                },
                                {
                                    title: "Approval & Licensing",
                                    text: "Typically 6–12 months."
                                }
                            ]

                        }
                    />

                    <TimelineSection
                        title='Timeline & Costs'
                        items={
                            [
                                {
                                    name: "Timeline",
                                    duration: "6–12 months.",
                                },
                                {
                                    name: "Setup Costs",
                                    description: "from GBP 100,000+."
                                },
                                {
                                    name: "Capital Requirement",
                                    description: "EUR 100k–3.7m depending on license."
                                },
                                {
                                    name: "Annual Costs",
                                    description: "GFSC supervision, compliance, actuarial audits."
                                },

                            ]
                        }
                    />

                    <DetailsSection
                        title='Why Offshore Advisory?'
                        items={
                            [
                                {
                                    text: "Specialists in insurance & reinsurance licensing worldwide."
                                },
                                {
                                    text: "End-to-end support: incorporation, actuarial reports, GFSC filings."
                                },
                                {
                                    text: "Access to insurance managers, actuaries, and compliance officers."
                                },
                                {
                                    text: "Comparative insights: Gibraltar vs Malta vs Isle of Man vs Bermuda."
                                },
                                {
                                    text: "Long-term compliance & solvency support."
                                }
                            ]
                        }
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    <CTA
                        title="Looking to launch a regulated crypto business in Latin America?"
                        description="Panama offers crypto licensing under Law 697, with low barriers, tax advantages, and global flexibility."
                        buttonText="Book a Panama Crypto License Consultation →"
                        buttonLink="/quote"
                    />

                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "Why Gibraltar over Malta or IoM?",
        content: [
            { type: "answer", text: "Gibraltar offers direct UK market access and a stronger motor insurance cluster." },
        ],
    },
    {
        question: "Is Gibraltar Solvency II compliant?",
        content: [
            { type: "answer", text: "Yes — GFSC operates a Solvency II-equivalent regime." },
        ],
    },
    {
        question: "Can MGAs and brokers be licensed?",
        content: [
            { type: "answer", text: "Yes — Gibraltar licenses intermediaries, MGAs, and brokers." },
        ],
    },
    {
        question: "How much capital is required?",
        content: [
            { type: "answer", text: "EUR 100k for captives, up to EUR 3.7m for life insurers." },
        ],
    },
    {
        question: "How long does licensing take?",
        content: [
            { type: "answer", text: "6–12 months." },
        ],
    },
];

const testimonialsData = [
    {
        quote: "We established a captive in Gibraltar to self-insure group risks. Offshore Advisory managed the setup end-to-end.",
        author: "Peter H.",
        role: "CFO, Aviation Group"
    },
    {
        quote: "Gibraltar gave us direct access to the UK motor insurance market. Offshore Advisory ensured full GFSC compliance.",
        author: "Laura W.",
        role: "Insurance CEO"
    }
];